export default __webpack_public_path__ + "check-mark.758f5c91.png";